var exports = {
  "l9": "Trigger__x7-jAh",
  "RZ": "Active__v8AKXA",
  "z8": "TriggerLabel__4JZCo-",
};

module.exports = exports;
